var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 70,
    viewBox: "0 0 125 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2721 67.2343C53.2721 66.7505 53.6578 66.3623 54.1398 66.3623H66.6429C67.1258 66.3623 67.514 66.7496 67.514 67.2343C67.514 67.7172 67.1258 68.1071 66.6429 68.1071H54.1398C53.6595 68.1062 53.2721 67.7163 53.2721 67.2343ZM107.162 61.6881H16.8776V3.6317H103.55H107.162V19L107.075 33L107 59.5L104 59.0941V61.6881H107.162ZM120.784 67.6612C120.784 66.37 119.739 65.3233 118.453 65.3233V65.1572H106.09C106.72 64.8748 107.162 64.2421 107.162 63.5019L107 59.5L107.162 1.8137C107.162 0.811732 106.355 0 105.355 0H15.0708C14.0766 0 13.2657 0.811732 13.2657 1.8137V63.501C13.2657 64.237 13.7073 64.874 14.3374 65.1563H2.32932V65.3181C1.04329 65.3173 0 66.3657 0 67.6586C0 68.9515 1.04329 70 2.32932 70H118.453C119.741 69.9983 120.784 68.9524 120.784 67.6612Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 5,
    width: 29,
    height: 52,
    fill: "#1E2752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 7.58444V55.4156C91 57.3913 92.5857 59 94.5332 59H120.467C122.414 59 124 57.3913 124 55.4156V7.58444C124 5.60872 122.414 4.00003 120.467 4.00003H94.5332C92.5857 3.99222 91 5.60091 91 7.58444ZM121.645 7.58444V55.4156C121.645 56.0794 121.113 56.6104 120.467 56.6104H94.5332C93.8789 56.6104 93.3555 56.0716 93.3555 55.4156V7.58444C93.3555 6.92066 93.8866 6.38963 94.5332 6.38963H120.467C121.113 6.38963 121.645 6.92066 121.645 7.58444ZM105.141 49.4338C105.141 50.7535 106.195 51.8234 107.496 51.8234C108.797 51.8234 109.852 50.7535 109.852 49.4338C109.852 48.114 108.797 47.0442 107.496 47.0442C106.195 47.0442 105.141 48.114 105.141 49.4338Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon1);
export default __webpack_public_path__ + "static/media/discover-icon-1.2123db6b9ce632bf27c5f2e028e0a61b.svg";
export { ForwardRef as ReactComponent };